import * as React from 'react';
import useEnforce from '../../hooks/useEnforce';
import { permissions } from '../../util/abac';

export { permissions };

export interface EnforceABACOwnProps {
  permission?: string;
  orPermissions?: string[];
  andPermissions?: string[];
  children: any;
  unAuthorized?: any;
}

export type EnforceABACProps = EnforceABACOwnProps;

const EnforceABAC = (props: EnforceABACProps) => {
  const enforce = useEnforce();

  const {
    permission,
    orPermissions = [],
    andPermissions = [],
    children,
    unAuthorized = null,
  } = props;

  if (
    !permission &&
    orPermissions.length === 0 &&
    andPermissions.length === 0
  ) {
    console.error('Enforce ABAC must be supplied with permissions');
    return unAuthorized;
  }

  if (orPermissions.length > 0) {
    return orPermissions.some(permission => enforce(permission))
      ? children
      : unAuthorized;
  } else if (andPermissions.length > 0) {
    return andPermissions.find(permission => !enforce(permission))
      ? unAuthorized
      : children;
  } else {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    return enforce(permission) ? children : unAuthorized;
  }
};

export default React.memo(EnforceABAC);
